import React, { useState, useEffect, useCallback } from 'react';
import { FiMail, FiPhone, FiEdit2, FiHash, FiMapPin, FiBriefcase, FiFileText, FiEye } from 'react-icons/fi';
import Modal from './Modal';
import { authFetch } from '../../utils/api';
import InvoicePreviewModal from './InvoicePreviewModal';

const ViewCustomerModal = ({ show, onClose, customer, onEdit }) => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewingInvoice, setViewingInvoice] = useState(null);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);

  const fetchCustomerInvoices = useCallback(async () => {
    if (!customer?.customer_id) return;

    setLoading(true);
    try {
      const response = await authFetch(`/customers/${customer.customer_id}/invoices`);
      if (response.ok) {
        const data = await response.json();
        setInvoices(data);
      }
    } catch (error) {
      console.error('Error fetching customer invoices:', error);
    } finally {
      setLoading(false);
    }
  }, [customer?.customer_id]);

  useEffect(() => {
    if (show && customer?.customer_id) {
      fetchCustomerInvoices();
    }
  }, [show, customer, fetchCustomerInvoices]);

  const handleViewInvoice = (invoice) => {
    setViewingInvoice(invoice);
    setIsInvoiceModalOpen(true);
  };

  if (!show || !customer) return null;

  const footer = (
    <>
      <button className="btn btn-secondary" onClick={onClose}>
        Close
      </button>
      {onEdit && (
        <button className="btn btn-primary" onClick={onEdit}>
          <FiEdit2 style={{ marginRight: 4 }} />
          Edit Customer
        </button>
      )}
    </>
  );

  return (
    <>
      <Modal show={show} onClose={onClose} title="Customer Details" footer={footer}>
        <div className="detail-group">
          <label>Customer ID</label>
          <p>{customer.id}</p>
        </div>
        <div className="detail-group">
          <label>Name</label>
          <p>{customer.name}</p>
        </div>
        <div className="detail-group">
          <label>Email</label>
          <p><FiMail style={{ marginRight: 4 }} />{customer.email}</p>
        </div>
        <div className="detail-group">
          <label>Phone</label>
          <p><FiPhone style={{ marginRight: 4 }} />{customer.phone}</p>
        </div>
        <div className="detail-group">
          <label>GST Number</label>
          <p><FiHash style={{ marginRight: 4 }} />{customer.gstin || 'Not provided'}</p>
        </div>
        <div className="detail-group">
          <label>Company</label>
          <p><FiBriefcase style={{ marginRight: 4 }} />{customer.company || 'Not provided'}</p>
        </div>
        <div className="detail-group">
          <label>Address</label>
          <p><FiMapPin style={{ marginRight: 4 }} />{customer.address || 'Not provided'}</p>
        </div>
        <div className="detail-group">
          <label>State</label>
          <p><FiMapPin style={{ marginRight: 4 }} />{customer.state || 'Not provided'}</p>
        </div>
        <div className="detail-group">
          <label>Notes</label>
          <p><FiFileText style={{ marginRight: 4 }} />{customer.notes || 'No notes'}</p>
        </div>
        <div className="detail-group">
          <label>Total Spent</label>
          <p>₹{Number(customer.total_spent || 0).toFixed(2)}</p>
        </div>
        <div className="detail-group">
          <label>Last Invoice</label>
          <p>{customer.last_invoice ? new Date(customer.last_invoice).toLocaleDateString() : 'No invoices yet'}</p>
        </div>
        <div className="detail-group">
          <label>Status</label>
          <span className={`status-badge ${customer.status?.toLowerCase() || 'active'}`}>{customer.status || 'Active'}</span>
        </div>

        {/* Invoices Section */}
        <div className="detail-group">
          <label>Customer Invoices</label>
          <div style={{ marginTop: '10px' }}>
            {loading ? (
              <p>Loading invoices...</p>
            ) : invoices.length > 0 ? (
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {invoices.map((invoice) => (
                  <div key={invoice.invoice_id} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px',
                    border: '1px solid #eee',
                    borderRadius: '4px',
                    marginBottom: '8px',
                    backgroundColor: '#f9f9f9'
                  }}>
                    <div>
                      <strong>{invoice.invoice_number}</strong>
                      <br />
                      <small>{invoice.invoice_date} - ₹{invoice.total}</small>
                    </div>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleViewInvoice(invoice)}
                      style={{ padding: '4px 8px', fontSize: '12px' }}
                    >
                      <FiEye style={{ marginRight: '4px' }} />
                      View
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ color: '#666', fontStyle: 'italic' }}>No invoices found for this customer</p>
            )}
          </div>
        </div>
      </Modal>

      {/* Invoice Preview Modal */}
      <InvoicePreviewModal
        show={isInvoiceModalOpen}
        onClose={() => setIsInvoiceModalOpen(false)}
        invoice={viewingInvoice}
      />
    </>
  );
};

export default ViewCustomerModal; 